import { useEffect, useState } from "react";

const windowSize = () => (window.innerWidth > 991 ? true : false);
const rootElement =
  document.querySelector("#root") ||
  document.querySelector('[data-controller="symfony--ux-react--react"]');

function useWindowSize() {
  const [isDesktop, setIsDesktop] = useState(windowSize);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [rootWidth, setRootWidth] = useState(rootElement.clientWidth);

  const handleWindowSizeChange = () => {
    setIsDesktop(windowSize);
    setInnerWidth(window.innerWidth);
    setRootWidth(rootElement.clientWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return { isDesktop, innerWidth, rootWidth };
}
export default useWindowSize;
